import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import { authSlice, chartSlice, transactionSlice, uiSlice } from './';
import { userSlice } from './users/userSlice';

export const store = configureStore({
  reducer: {
    user: userSlice.reducer,
    auth: authSlice.reducer,
    ui: uiSlice.reducer,
    chart: chartSlice.reducer,
    transaction: transactionSlice.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

// Definir el tipo de estado de la tienda
export type RootState = ReturnType<typeof store.getState>;

// Definir el tipo de AppDispatch
export type AppDispatch = typeof store.dispatch;

// Definir el tipo de Thunk
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
